import { LinkSquarePage } from '../../pages/linksquare';

export const LinkSquareView = () => {
  return (
    <>
      <LinkSquarePage />
    </>
  );
};
